/**
 * GraphQL query for listing ABR filters for a community.
 */

import { gql } from '@apollo/client';

export const GET_ABR_FILTERS = gql`
  query GetAbrFilters($communityId: ID!) {
    abrFilters(communityId: $communityId) {
      filters {
        id
        communityId
        name
        description
        criteria {
          reportedContent
          textLabelFilters {
            labelId
            contentType
            minSeverity
            minScore
          }
          textLabelFilterModifier
          imageLabelFilters {
            labelId
            contentType
            minSeverity
            minScore
          }
          imageLabelFilterModifier
        }
        createdAt
        createdBy
      }
      totalCount
    }
  }
`;
